import { useCallback } from 'react';
import { escapeEmojis } from 'modules/codeless-events/utils/stringUtils';

const safeValueHandler = value => value?.trim() || '';
export const useHandleButtonAnalyzerClick = ({
    currentConversion,
    updateDraftEvent,
    selectedButtons = [],
    setSelectedButtons,
    setFocusedConversionId,
}) => {
    const isAlreadySelectedHandler = useCallback(
        ({ buttonData }) => {
            return selectedButtons.some(button => {
                const selectorMatches = button.selector === buttonData?.path;
                if (selectorMatches) {
                    const selectedText = safeValueHandler(button.displayTextUnescaped);
                    const clickedText = safeValueHandler(buttonData.eventName);
                    return selectedText === clickedText;
                }
                return selectorMatches;
            });
        },
        [selectedButtons]
    );
    return useCallback(
        buttonData => {
            if (currentConversion && buttonData) {
                const eventId = currentConversion.id;
                const isAlreadySelected = isAlreadySelectedHandler({ buttonData });
                let newSelectedButtons;
                if (isAlreadySelected) {
                    newSelectedButtons = selectedButtons.filter(button => {
                        const selectorMatches = button.selector === buttonData.path;

                        if (selectorMatches) {
                            const selectedText = safeValueHandler(button.displayTextUnescaped);
                            const clickedText = safeValueHandler(buttonData.eventName);
                            return selectedText !== clickedText;
                        }
                        return !selectorMatches;
                    });
                } else {
                    const newButton = {
                        displayText: escapeEmojis(buttonData.eventName),
                        displayTextUnescaped: buttonData.eventName,
                        selector: buttonData.path,
                        valueSelector: undefined,
                    };
                    newSelectedButtons = [...selectedButtons, newButton];
                }

                setSelectedButtons(newSelectedButtons);

                if (updateDraftEvent) {
                    updateDraftEvent(draft => ({
                        ...draft,
                        trackedElements: newSelectedButtons,
                    }));
                }

                if (setFocusedConversionId) {
                    setFocusedConversionId(eventId);
                }
            }
        },
        [
            currentConversion,
            isAlreadySelectedHandler,
            selectedButtons,
            setSelectedButtons,
            updateDraftEvent,
            setFocusedConversionId,
        ]
    );
};
